var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeth2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6413_60163)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.66663,
    width: 11.3137,
    height: 11.3137,
    rx: 2,
    transform: "rotate(45 8.66663 0)",
    fill: "#D1ADFF",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54944 7.7445L5.5526 7.74302L8.64587 9.55348V9.55357L8.64596 9.55353L8.64604 9.55357V9.55348L11.7393 7.74302L11.7424 7.7445L11.7409 7.74204L11.7424 7.74117L11.7396 7.73989L8.64604 2.57547V2.5752L8.64596 2.57533L8.64587 2.5752V2.57547L5.5522 7.73989L5.54944 7.74117L5.55091 7.74204L5.54944 7.7445ZM8.64596 10.2217L5.54944 8.36523L8.64587 12.8106V12.8108L8.64596 12.8107L8.64604 12.8108V12.8106L11.7424 8.36523L8.64596 10.2217Z",
    fill: "#131313"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6413_60163"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeth2);
export default __webpack_public_path__ + "static/media/icon-deth2.f89d305e.svg";
export { ForwardRef as ReactComponent };